module.exports = __webpack_public_path__ + "static/media/angle-down.4c4afc3c.svg";